import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useCaja } from '../context/CajaContext';

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user, loading } = useAuth();
  const { cajaAbierta, cajaRequired, initialized: cajaInitialized } = useCaja();
  const { pathname } = useLocation();

  if (loading) return <p>Cargando...</p>;
  if (!user?.isAuthenticated) return <Navigate to="/login" />;
  if (cajaRequired && !cajaInitialized) return <p>Cargando...</p>;

  const role = user?.role || user?.rol;
  if (Array.isArray(allowedRoles) && allowedRoles.length > 0) {
    if (!allowedRoles.includes(role)) return <Navigate to="/dashboard" />;
  }

  if (cajaRequired && cajaInitialized && !cajaAbierta && pathname !== '/caja') {
    return <Navigate to="/caja" replace />;
  }

  return children;
};

export default ProtectedRoute;
